import React, { useEffect } from "react";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { About } from "../components/About";
import { Services } from "../components/Services";
import { Process } from "../components/Process";
import { Footer } from "../components/Footer";
import { DEFAULT_SERVICES } from "../lib/catalog";

export default function HomePage() {
  useEffect(() => {
    document.title = "Notaris Helen Parlista | Notaris & PPAT Indramayu";
    const metaDescription = document.querySelector("meta[name=description]");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Notaris & PPAT Helen Parlista di Indramayu: layanan pendirian PT/CV, AJB, waris, perjanjian pranikah, wasiat, dan legalisasi dokumen."
      );
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <Header />
      <Hero />
      <About />
      <Services services={DEFAULT_SERVICES} />
      <Process />
      <Footer />
    </div>
  );
}
